
import React, { useEffect } from "react";
import HeroSection from "@/components/HeroSection";
import ExploreSection from "@/components/ExploreSection";
import MentorsSection from "@/components/MentorsSection";
import TeamSection from "@/components/TeamSection";
import CtaSection from "@/components/CtaSection";
import FeaturedFounders from "@/components/founders/FeaturedFounders";
import FeaturedStartups from "@/components/startup/FeaturedStartups";
import { useAuth } from "@/contexts/AuthContext";
import { motion } from "framer-motion";

const Index = () => {
  const { user } = useAuth();

  useEffect(() => {
    // Log when Index page renders
    console.log("Index page rendered");
    
    // Check if the navbar and other components are rendering
    const navbarElement = document.querySelector('nav');
    console.log("Navbar found:", !!navbarElement);
    
    const mainElement = document.querySelector('main');
    console.log("Main content found:", !!mainElement);
  }, []);

  // Animation variants for sections
  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  return (
    <motion.div 
      className="flex flex-col min-h-screen w-full"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      <main className="flex-grow">
        <motion.div variants={sectionVariants}>
          <HeroSection />
        </motion.div>

        <motion.div variants={sectionVariants}>
          <ExploreSection />
        </motion.div>

        {/* Show featured sections for signed-in users */}
        {user && (
          <>
            <motion.div variants={sectionVariants}>
              <FeaturedFounders />
            </motion.div>
            
            <motion.div variants={sectionVariants}>
              <FeaturedStartups />
            </motion.div>
          </>
        )}
        
        <motion.div variants={sectionVariants}>
          <MentorsSection />
        </motion.div>
        
        <motion.div variants={sectionVariants}>
          <TeamSection />
        </motion.div>
        
        <motion.div variants={sectionVariants}>
          <CtaSection />
        </motion.div>
      </main>
    </motion.div>
  );
};

export default Index;
